import React from 'react'
import { useTranslation } from '@hooks/useTranslation'
import { useDocument } from '@EUForms/hooks/useDocument'
import RepeatableContainer from '@containers/repeatableContainer'
import ContainerDetails from './containerDetails'
import { containerTabActions } from '../../reducer/containerSlice'

const Containers = () => {
  const translate = useTranslation()
  const { updateContainerField, deleteContainerField, addContainerField, updateContainerHierarchy } = containerTabActions
  const { ...rest } = useDocument({
    addData: addContainerField,
    deleteData: deleteContainerField,
    updateData: updateContainerField,
    containerKey: 'containerTab',
  })

  return (
    <RepeatableContainer
      {...rest}
      tableName='containersList'
      reducerName='containerReducer'
      translate={translate}
      renderForm={(params) => <ContainerDetails 
        saveItem={rest?.saveItem}
        updateContainerHierarchy={updateContainerHierarchy}
        {...params} 
      />}
    />
  )
}

export default React.memo(Containers)
